var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WrappedForm',{ref:"form",staticClass:"group-editor",attrs:{"label-position":"top","label-bold":"","hide-required-asterisk":"","model":_vm.groupData,"formLines":_vm.formLines}})
}
var staticRenderFns = []

export { render, staticRenderFns }